<template>
<v-app>
    <v-main app>
        <v-img src="https://firebasestorage.googleapis.com/v0/b/breakstamp.appspot.com/o/landing%2FLanding%20Page.jpg?alt=media&token=ceea2e2e-9415-41c9-84d0-d194143a0435"></v-img>
    </v-main>
    <v-footer app class="ma-0 pa-0">
        <div
            elevation="0"
            :ripple="false"
            class="
              font-weight-bold
              py-5
              text-sm
              d-flex
              justify-center
            "
            style="color:white;width:100%;background-color:#EE7E71;cursor:pointer"
            @click="goLink">
            도장깨기 앱 다운로드
        </div>
    </v-footer>
</v-app>
</template>

<script>
export default {
    name: 'App',

    components: {},

    data: () => ({
        //
    }),

    methods: {
      goLink() {
        // iPadOS 13+ Safari는 데스크톱(Macintosh) UA를 보내므로 터치 지원 여부로 보완한다.
        const ua = navigator.userAgent || '';
        const isIOS = /iPhone|iPad|iPod/i.test(ua) ||
          (/Macintosh/i.test(ua) && navigator.maxTouchPoints > 1);
        location.href = isIOS
          ? 'https://apps.apple.com/app/id6443554401'
          : 'https://play.google.com/store/apps/details?id=com.gooddatalab.breakstamp';
      }
    }
};
</script>
